import { ColorBluViu, ColorGreen, ColorLightBlue, ColorOrange } from 'theme-colors';

import { ChartPalette } from 'components/charts/types/chart-palette.type';
import { ChartMode, ChartPaletteOption } from 'components/charts/types/chart-settings.type';

export const CHART_PALETTE = [
  ColorBluViu.main,
  ColorGreen.dark || ColorGreen.main,
  ColorOrange.dark || ColorOrange.main,
  ColorBluViu.dark || ColorBluViu.main,
  ColorBluViu.o75 || ColorBluViu.main,
  ColorLightBlue.main,
];

export const COLOR_BLIND_SAFE_CATEGORICAL: string[] = [
  '#E69F00',
  '#56B4E9',
  '#009E73',
  '#F0E442',
  '#0072B2',
  '#D55E00',
  '#CC79A7',
  '#8A8A8A',
];

const DARK_CHART_PALETTE: ChartPalette = {
  backgrounds: {
    canvas: '#01161F',
    surface: '#012231',
    raised: '#06303F',
    sunken: '#011A26',
  },
  borders: {
    subtle: '#0E3C4E',
    strong: '#17546C',
  },
  text: {
    primary: '#F2F7FA',
    secondary: '#A8C0CC',
    disabled: '#6B8493',
  },
  series: {
    categorical: ['#37C8BC', '#E292F2', '#E75577', '#65B139', '#F7E9C8', '#4984E9', '#AA8741', '#CD7AAB'],
  },
  status: {
    green: '#3ED8A0',
    amber: '#FFC24D',
    red: '#FF5C6B',
  },
  shadow: 'none',
};

const LIGHT_CHART_PALETTE: ChartPalette = {
  backgrounds: {
    canvas: '#F4F8FA',
    surface: '#FFFFFF',
    raised: '#FFFFFF',
    sunken: '#EDF3F7',
  },
  borders: {
    subtle: '#DCE7ED',
    strong: '#B8CCDA',
  },
  text: {
    primary: '#012231',
    secondary: '#4A6472',
    disabled: '#8CA3AF',
  },
  series: {
    categorical: ['#0F8F84', '#9B3FB5', '#C2325C', '#3F7A22', '#0F2847', '#2A62C4', '#A87519', '#B2578F'],
  },
  status: {
    green: '#12885E',
    amber: '#B8790A',
    red: '#C2283C',
  },
  shadow: '0 1px 2px rgba(1, 34, 49, 0.06), 0 8px 24px rgba(1, 34, 49, 0.06)',
};

const CHART_PALETTES: Record<ChartMode, ChartPalette> = {
  dark: DARK_CHART_PALETTE,
  light: LIGHT_CHART_PALETTE,
};

export const getChartPalette = (mode: ChartMode, option: ChartPaletteOption): ChartPalette => {
  const basePalette = CHART_PALETTES[mode];
  const categorical =
    option === 'legacy'
      ? CHART_PALETTE
      : option === 'colorBlindSafe'
        ? COLOR_BLIND_SAFE_CATEGORICAL
        : basePalette.series.categorical;

  return categorical === basePalette.series.categorical
    ? basePalette
    : { ...basePalette, series: { ...basePalette.series, categorical } };
};
